//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { ILegacyInstagramUser } from '@models/ILegacyInstagramUser';
import InstagramBusinessAccountId from '@models/InstagramBusinessAccountId';
import InstagramUserId from '@models/InstagramUserId';
import { IMetadataResponse } from '@models/MetricsGatewayApiModels';
import { hasPermissionForTask } from '@services/permissions';

export interface IInstagramAccountState {
  sessionState?: IInstagramAccountSessionState;
  defaultInstagramAccount?: IDefaultInstagramAccount;
  instagramBusinessAccount?: InstagramBusinessAccountId;
  isFetchingDefaultInstagramAccount: boolean;
  insightsMetadata?: IMetadataResponse;
  errors: {
    fetchDefaultInstagramAccountError?: string;
  };
}

export interface IInstagramAccountSessionState {
  timeZoneId: string;
  timeZoneShortName: string;
  hasSchedulingPermissions: boolean;
  schedulingTaskName: string;
}

export interface IDefaultInstagramAccountInfo {
  defaultInstagramAccount: IDefaultInstagramAccount;
  businessAccountId: InstagramBusinessAccountId;
}

export interface IDefaultInstagramAccount extends ILegacyInstagramUser {
  accountId: InstagramUserId;
}

export const SCHEDULE_ITEM_TASK_NAME = 'publish:schedule_instagram_item';
export const hasPermissionToSchedule = () =>
  hasPermissionForTask(SCHEDULE_ITEM_TASK_NAME);
